export default "__VITE_PUBLIC_ASSET__8cadf155__"